// import mapboxgl from "mapbox-gl";
import ImageManager from "./ImageManager.class";
export class RasterImage {
    get appIds() {
        return this._appIds;
    }
    setAppId(id) {
        this.removeAppId(id);
        const appId = ImageManager.allAppIds.find((appId) => id === appId.id);
        if (appId) {
            this._appIds.push(appId);
        }
        else {
            console.error(`AppId for id "${id}" was not found in `, ImageManager.allAppIds);
        }
        this._imageManager.update();
    }
    removeAppId(_id) {
        this._appIds = this._appIds.filter((id) => id.id !== _id);
        this._imageManager.update();
    }
    get id() {
        return this._id;
    }
    get opacity() {
        return this._opacity;
    }
    set opacity(value) {
        if (!this._map)
            return;
        this._opacity = value;
        this._imageManager.crudData.update(this);
        this._imageManager.update();
    }
    get imageUrl() {
        return this._imageUrl;
    }
    set imageUrl(value) {
        this._imageUrl = value;
    }
    get imageString() {
        return this._imageString;
    }
    set imageString(value) {
        this._imageString = value;
    }
    get name() {
        return this._name;
    }
    set name(value) {
        this._name = value;
        this._prevState = {
            ...this._prevState,
            name: this._name,
        };
        this._imageManager.crudData.update(this);
    }
    get campusKey() {
        return this._campusKey;
    }
    set campusKey(value) {
        this._campusKey = value;
        this._imageManager.crudData.update(this);
    }
    get level() {
        return this._level;
    }
    set level(value) {
        this._level = value;
        this._imageManager.crudData.update(this);
    }
    get beforeId() {
        return this._beforeId;
    }
    set beforeId(value) {
        this._beforeId = value;
    }
    /**
     * Neue Koordinaten für das Image setzen, auch in der Map.
     */
    set corners(coordinates) {
        this._corners = coordinates;
        this._imageManager.crudData.update(this);
    }
    get corners() {
        return this._corners;
    }
    /**
     * @param arrayEndsWithFirst - Entweder man bekommt ein vierer Array zurück oder ein Fünfer, wo die letzte Value die gleiche wie die erste ist
     */
    getCorners({ arrayEndsWithFirst = false, strict = false } = {}) {
        if (!this._corners)
            return [];
        let returnCoordinates = [...this._corners];
        if (arrayEndsWithFirst &&
            returnCoordinates[0] !== returnCoordinates[returnCoordinates.length - 1]) {
            returnCoordinates.push(returnCoordinates[0]);
        }
        if (strict) {
            returnCoordinates = returnCoordinates.slice(0, 4);
        }
        return returnCoordinates;
    }
    constructor(options) {
        var _a;
        this._appIds = [];
        this.cornerSaveStates = new Map();
        this._prevState = {};
        this._id = options.id;
        this._imageUrl = options.url;
        this._imageString = options.imageString;
        this._fileType = options.fileType;
        this._name = options.name != null ? options.name : "image_" + this._id;
        this._opacity = options.opacity != null ? options.opacity : 1;
        this._level = options.level;
        this._campusKey = options.campusKey;
        this._imageManager = options.imageManager;
        this._appIds = (_a = options.appIds) !== null && _a !== void 0 ? _a : [];
        if (options.width != null && options.height != null) {
            this._dimensions = {
                width: options.width,
                height: options.height,
            };
        }
        this._beforeId = options.beforeId;
        this._opacity = options.opacity;
        this._map = options.map;
        // ts-ignore TODO DONT FORGET
        // Keine Ahnung warum das hier überhaupt drin war, yolo.
        // this._layers = this._map.getStyle().layers;
        if (options.corners) {
            this._corners = options.corners;
        }
        else {
            this._corners = this.getDisplayCenteredImageCoordinates();
        }
        return this;
    }
    fromJSON(object) {
        return new RasterImage({
            campusKey: object.campusKey,
            id: object.id,
            map: this._map,
            opacity: object.opacity,
            corners: object.corners,
            name: object.name,
            level: object.level,
            url: object.url,
            imageManager: object.imageManager,
            fileType: object.fileType,
            width: object.width,
            height: object.height,
            appIds: object.appIds,
        });
    }
    toJSON() {
        var _a, _b;
        if (this._level == null)
            throw Error(`Level of image ${this.name} is not given`);
        if (this.campusKey == null)
            throw Error(`No Campuskey given for image ${this.name}. Give the image manager a campuskey before uploading images `);
        if (this._imageString == null && this._imageUrl == null)
            throw Error(`For some reason ${this.name} has neither an imageString, nor a url`);
        const json = {
            corners: this._corners,
            id: this._id,
            name: this._name,
            opacity: this._opacity,
            level: this._level,
            imageString: this._imageString,
            height: (_a = this._dimensions) === null || _a === void 0 ? void 0 : _a.height,
            width: (_b = this._dimensions) === null || _b === void 0 ? void 0 : _b.width,
            campusKey: this.campusKey,
            beforeId: this._beforeId,
            fileType: this._fileType,
            appIds: this._appIds,
        };
        return json;
    }
    /**
     * Wenn man in den Bearbeitungsmodus geht, müssen die letzten Einstellungen gesaved werden
     * bevor sie geändert werden
     */
    saveState() {
        this._prevState = {
            level: this._level,
            corners: this._corners,
            opacity: this._opacity,
            name: this._name,
            campusKey: this._campusKey,
        };
    }
    /**
     * Die wird logischweise verwendet um das alte zu restoren
     */
    restoreSaveState() {
        if (this._prevState.level != null)
            this._level = this._prevState.level;
        if (this._prevState.opacity != null)
            this._opacity = this._prevState.opacity;
        if (this._prevState.name != null)
            this._name = this._prevState.name;
        if (this._prevState.corners)
            this._corners = this._prevState.corners;
    }
    /**
     * Gibt die Koordinaten der Mapbounds mit etwas Padding heraus
     */
    getDisplayCenteredImageCoordinates() {
        if (!this._map)
            return undefined;
        const bounds = this._map.getBounds();
        // bounds umwandeln in 4er array
        return this.getPaddedCoordinates(
        // @ts-ignore
        bounds._sw.lng, 
        // @ts-ignore
        bounds._ne.lat, 
        // @ts-ignore
        bounds._ne.lng, 
        // @ts-ignore
        bounds._ne.lat, 
        // @ts-ignore
        bounds._ne.lng, 
        // @ts-ignore
        bounds._sw.lat, 
        // @ts-ignore
        bounds._sw.lng, 
        // @ts-ignore
        bounds._sw.lat);
    }
    /** Straightens up the image to be in the original square form it was uploaded in.
     * Necessary when using AB Pinning
     */
    straighten() {
        var _a, _b;
        if (((_a = this._dimensions) === null || _a === void 0 ? void 0 : _a.height) != null && ((_b = this._dimensions) === null || _b === void 0 ? void 0 : _b.width) != null) {
            this._corners = this.getDisplayCenteredImageCoordinates();
        }
    }
    /**
     * Nimmt die Bounds und gibt das Ergebnis mit nem Padding zurück
     */
    getPaddedCoordinates(nwLng, nwLat, neLng, neLat, seLng, seLat, swLng, swLat) {
        var _a;
        const paddingPercent = 0.3;
        nwLng = nwLng + (neLng - nwLng) * paddingPercent;
        neLng = neLng - (neLng - nwLng) * paddingPercent;
        swLng = swLng + (seLng - swLng) * paddingPercent;
        seLng = seLng - (seLng - swLng) * paddingPercent;
        nwLat = nwLat - (nwLat - swLat) * paddingPercent;
        neLat = neLat - (neLat - seLat) * paddingPercent;
        swLat = swLat + (nwLat - swLat) * paddingPercent;
        seLat = seLat + (neLat - seLat) * paddingPercent;
        // Falls height und width verfügbar sind, dann soll
        // das Seitenverhältnis angepasst werden
        if (((_a = this._dimensions) === null || _a === void 0 ? void 0 : _a.height) != null) {
            const lng_ratio = this.getAspectRatioCoordinates(nwLng, swLat, nwLat);
            if (lng_ratio) {
                neLng = lng_ratio;
                seLng = lng_ratio;
            }
        }
        return [
            [nwLng, nwLat],
            [neLng, neLat],
            [seLng, seLat],
            [swLng, swLat],
        ];
    }
    /** Move this RasterImage one layer up */
    layerUp() {
        this._moveLayer("up", "Layer already at the top");
    }
    layerDown() {
        this._moveLayer("down", "Layer already at the bottom");
    }
    _moveLayer(type, warning) {
        // const layers: string[] = [];
        const layers = this._map.orderedLayerIds;
        if (!layers) {
            console.warn("Did not receive layers from map.orderedLayerIds");
            return;
        }
        if (layers.length < 1) {
            console.warn(`No Indoorlayers for moving RasterImage ${this.name} up and down. 
      Check if your indoor plans are available!`, this._map);
            return;
        }
        const withoutBeforeId = () => {
            var _a;
            if (type === "up") {
                console.warn(warning);
            }
            else {
                // dont't let the layer go under 0
                this.beforeId = (_a = layers[layers.length - 1]) !== null && _a !== void 0 ? _a : layers[0];
            }
        };
        const withBeforeId = () => {
            let beforeIdInLayers = false;
            let layerToMoveTo;
            layers.forEach((layer, index) => {
                if (layer === this._beforeId) {
                    beforeIdInLayers = true;
                    layerToMoveTo = layers[index + (type === "up" ? 1 : -1)];
                    if (!layerToMoveTo) {
                        if (type === "down") {
                            // dont't let the layer go under 0
                            console.warn(warning);
                            layerToMoveTo = layers[0];
                        }
                        else {
                            console.warn(warning);
                        }
                    }
                }
            });
            // if the layer goes up and is undefined, thats okay, because then it's just
            // gonna show up on top
            this.beforeId = layerToMoveTo;
            if (!beforeIdInLayers) {
                // if the beforeId, the RasterImage came with, is not in the map layers -> reset it
                this._beforeId = undefined;
                withoutBeforeId();
            }
        };
        if (this._beforeId != null) {
            withBeforeId();
        }
        else {
            withoutBeforeId();
        }
        this._imageManager.crudData.update(this);
        this._imageManager.update();
    }
    /**
     * Manipuliert jeweils den Lng so, dass der AspectRatio des Bildes passt und das
     * Bild ned gestreckt ist
     */
    getAspectRatioCoordinates(nwLng, swLat, nwLat) {
        if (!this._dimensions)
            return undefined;
        const { width, height } = this._dimensions;
        const ratio = width / height;
        const lngLatDiffFactor = 1.55;
        const latDiff = (nwLat - swLat) * lngLatDiffFactor;
        const lng_ratio = nwLng + latDiff * ratio;
        return lng_ratio;
    }
    getIdentifier() {
        return this._id;
    }
    getLayerId() {
        return "rasterImage_id_" + this.id;
    }
}
